.button-group {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  justify-content: flex-end;
}

.button-group--stacked {
  flex-direction: column;
}

.button-group--reversed {
  flex-flow: row-reverse wrap-reverse;
  justify-content: flex-start;
}

.button-group--reversed-stacked {
  flex-direction: column-reverse;
}
